<form [formGroup]="form">
  <div class="w-auto" style="margin-left: 5px">
    <div
      class="input-group date"
      style="width: 17rem"
      id="dt-date"
      data-target-input="nearest"
    >
      <div
        class="input-group-text bg-primary"
        data-target="#dt-date"
        [owlDateTimeTrigger]="dt"
      >
        <i
          class="icofont icofont-ui-calendar"
          style="color: white; font-size: 12px"
        ></i>
      </div>
      <input
        style="font-size: 12px"
        width="max-content"
        [formControlName]="inputFormControlName"
        class="form-control datetimepicker-input digits"
        type="text"
        name="daterange"
        [placeholder]="'placehorderPickDate' | translate"
        [selectMode]="'range'"
        [owlDateTimeTrigger]="dt"
        [owlDateTime]="dt"
        [max]="max"
        [min]="min"
      />
    </div>
    <owl-date-time [pickerType]="'calendar'" #dt></owl-date-time>
  </div>
</form>
